var Authentication = require('./src/authentication');
var Module = require('./src/module');
var Language = require('./src/language');
var User = require('./src/user/user');
var Category = require('./src/category/category');
var Feed = require('./src/feed/feed');
var Hashtag = require('./src/hashtag');
var Wall = require('./src/wall');
var Branch = require('./src/branch/branch');
var Company = require('./src/company/company');
var PhoenixJS = require('./src/phoenix');
var Group = require("./src/message/group");
var Feedback = require("./src/feedback/feedback");
var Domain = require("./src/domain");

/**
  For method calls that require parameters
    - `company` <> integer -> All methods
    - `userId` <> integer -> For methods that require authorization.
    - `token` <> integer -> For methods that require authorization.
**/
function AhtapotJS(parameters){
  var self = this;
  var parameters = parameters;
  self.companyId = null;
  self.companyDomain = null;
  if (typeof parameters === "undefined" || parameters === null ||
      typeof parameters.companyId === "undefined" || parameters.companyId === null) {
    console.error("required parameters is null");
    return new Error("required parameters is null");
  } else {
    self.companyId = parameters.companyId;
    self.companyDomain = parameters.domain;
  }
  self.userId = null;
  self.token = parameters.token;
}

AhtapotJS.prototype.authentication = function(){
  var self = this;
  return new Authentication(self)
},
AhtapotJS.prototype.user = function(){
  var self = this;
  return new User(self);
}

AhtapotJS.prototype.module = function(){
  var self = this;
  return new Module(self);
}

AhtapotJS.prototype.category = function(){
  var self = this;
  return new Category(self);
}

AhtapotJS.prototype.feed = function(){
  var self = this;
  return new Feed(self);
}

AhtapotJS.prototype.language = function(){
  var self = this;
  return new Language(self);
}

AhtapotJS.prototype.company = function(){
  var self = this;
  return new Company(self);
}

AhtapotJS.prototype.branch = function(){
  var self = this;
  return new Branch(self);
}

AhtapotJS.prototype.hashtag = function(){
  var self = this;
  return new Hashtag(self);
}

AhtapotJS.prototype.wall = function(){
  var self = this;
  return new Wall(self);
}

AhtapotJS.prototype.message = function(){
  var self = this;
  return new Group(self);
};

AhtapotJS.prototype.feedback = function(){
  var self = this;
  return new Feedback(self);
}

AhtapotJS.prototype.domain = function(){
  var self = this;
  return new Domain(self);
}

AhtapotJS.prototype.phoenixJS = PhoenixJS;

module.exports = AhtapotJS;
